export function getBoundsFromGeometry(geometry) {
  if (!geometry || (geometry.type !== "Polygon" && geometry.type !== "MultiPolygon")) return null;

  let bounds = null;
  const coords = geometry.type === "Polygon" ? [geometry.coordinates] : geometry.coordinates;

  coords.forEach((polygon) => {
    polygon[0].forEach(([lng, lat]) => {
      if (!bounds) bounds = [[lat, lng], [lat, lng]];
      else {
        bounds[0][0] = Math.min(bounds[0][0], lat);
        bounds[0][1] = Math.min(bounds[0][1], lng);
        bounds[1][0] = Math.max(bounds[1][0], lat);
        bounds[1][1] = Math.max(bounds[1][1], lng);
      }
    });
  });

  return bounds;
}
